import { Box, Stack } from '@mui/material';

import { Card } from '@/components/layout/Card/Card';
import { EntityDocumentViewer_FilePageFragment } from '@/modules/documents/components/HouseholdDocumentsViewer/graphql/EntityDocumentViewer.generated';
import { PDFSource, PDFViewerLazy } from '@/modules/pdf/PDFViewer';
import { DocumentChromeProps } from '@/modules/pdf/PDFViewer/DocumentChrome';
import { COLORS } from '@/styles/tokens/colors';

type DocumentViewerDocumentChromeProps = DocumentChromeProps;

export function DocumentViewerDocumentChrome({
  children,
  shouldCenterContent,
  scrollContainerRef,
  sx = {},
}: DocumentViewerDocumentChromeProps) {
  return (
    <Card
      inputRef={scrollContainerRef}
      data-name="DocumentViewerDocumentChrome"
      variant="outlined"
      sx={{
        height: '100%',
        width: '100%',
        backgroundColor: COLORS.PRIMITIVES.WHITE,
        boxShadow: 'none !important',
        overflowY: 'auto',
        p: 2,
        borderRadius: 0,
        ...sx,
      }}
    >
      <Box
        sx={{
          border: `1px solid ${COLORS.GRAY[200]}`,
          position: 'relative',
          width: '100%',
          height: shouldCenterContent ? '100%' : 'auto',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: shouldCenterContent ? 'center' : 'start',
        }}
      >
        {children}
      </Box>
    </Card>
  );
}

interface DocumentDetailsDocumentViewerProps {
  loading: boolean;
  documentId: string;
  source: PDFSource | null;
  documentFilePages: EntityDocumentViewer_FilePageFragment[];
}

export function DocumentDetailsDocumentViewer({
  loading,
  documentId,
  source,
  documentFilePages,
}: DocumentDetailsDocumentViewerProps) {
  return (
    <Stack flex={1} height="100%" overflow="auto">
      <Card
        data-name="DocumentViewer-container"
        variant="transparent"
        sx={{
          height: '100%',
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          position: 'relative',
        }}
      >
        <PDFViewerLazy
          loading={loading}
          documentId={documentId}
          source={source}
          slots={{
            DocumentChrome: DocumentViewerDocumentChrome,
          }}
          filePages={documentFilePages}
        />
      </Card>
    </Stack>
  );
}
